import React, {createContext, useContext, useCallback, useState, useMemo} from 'react';
import {usePostHog} from 'posthog-js/react';

const TasksSidePanelContext = createContext(null);

const TasksSidePanelProvider = ({children}) => {
  const [showTasksSection, setShowTasksSection] = useState(false);
  const [taskStatusVersion, setTaskStatusVersion] = useState(0);
  const posthog = usePostHog();

  const handleShowSidePanel = useCallback(() => {
    posthog?.capture('tasks_annotations_open_side_panel');
    setShowTasksSection(true);
  }, [posthog]);

  const handleCloseSidePanel = useCallback(() => {
    posthog?.capture('tasks_annotations_close_side_panel');
    setShowTasksSection(false);
  }, [posthog]);

  const notifyTaskStatusUpdate = useCallback(() => {
    setTaskStatusVersion((version) => version + 1);
  }, []);

  const value = useMemo(() => ({
    showTasksSection,
    handleShowSidePanel,
    handleCloseSidePanel,
    taskStatusVersion,
    notifyTaskStatusUpdate,
  }), [showTasksSection, handleShowSidePanel, handleCloseSidePanel, taskStatusVersion, notifyTaskStatusUpdate]);

  return (
    <TasksSidePanelContext.Provider value={value}>
      {children}
    </TasksSidePanelContext.Provider>
  );
};

export const useTasksSidePanel = () => {
  const context = useContext(TasksSidePanelContext);
  if (!context) {
    throw new Error('useTasksSidePanel must be used within a TasksSidePanelProvider');
  }
  return context;
};

export default TasksSidePanelProvider;
